var map = {
	"./29.mp3": "f51c",
	"./30.mp3": "2505",
	"./31.mp3": "4cfb",
	"./32.mp3": "78d1",
	"./33.mp3": "766d",
	"./34.mp3": "f74e",
	"./35.mp3": "44e9",
	"./36.mp3": "4d99",
	"./37.mp3": "2402",
	"./38.mp3": "77d3",
	"./39.mp3": "79a6",
	"./40.mp3": "e274",
	"./41.mp3": "4100",
	"./42.mp3": "c8bf",
	"./M_Brilliant.mp3": "1d9f",
	"./M_Excellent.mp3": "9b05",
	"./M_Fantastic.mp3": "76e6",
	"./M_Great.mp3": "944a",
	"./M_Perfect.mp3": "050a",
	"./M_Think again.mp3": "8cd7",
	"./M_Try again.mp3": "87cb",
	"./M_Very good.mp3": "9b67",
	"./M_Well done.mp3": "50db",
	"./M_Work harder.mp3": "a965",
	"./click.mp3": "aa32",
	"./false.mp3": "91c4",
	"./true.mp3": "9ca3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a54e";